import { render, staticRenderFns } from "./ComissoesServicos.vue?vue&type=template&id=ba9dfde4&scoped=true&"
import script from "./ComissoesServicos.vue?vue&type=script&lang=js&"
export * from "./ComissoesServicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9dfde4",
  null
  
)

export default component.exports